import React from 'react'

// import { IpsaGreen } from '../../../../../highcharts/HighchartsStyleHelper'

import StripePortalButton from '../../../components/StripePortalButton'

const DisplayPlans = ({ selectedPlan, paymentSetup, goodStanding, discountPriceActive = '' }) => {
    const { name, subName, price, stripePlanId, features, discountPrice } = selectedPlan

    return (
        <div className="planContainer">
            <div key={stripePlanId} className="plan">
                <div className={'headerContainer headerContainer-1'}>
                    <div>{name}</div>
                    {discountPriceActive || discountPrice ? (
                        <div className="discount">
                            <span
                                style={{
                                    textDecoration: 'line-through',
                                    paddingRight: '5px',
                                }}
                            >
                                ${price}
                            </span>
                            <span> ${discountPriceActive}</span>
                        </div>
                    ) : (
                        <div>${price}</div>
                    )}
                    {subName && (
                        <div className="desc">
                            <em>{subName}</em>
                        </div>
                    )}
                </div>
                <div className="infoContainer">
                    <ul className="features">
                        {(features ?? []).map((_) => (
                            <li key={_}>{_}</li>
                        ))}
                    </ul>
                </div>
                <div className="infoContainer">
                    <StripePortalButton
                        // btnStyles={{
                        //     backgroundColor: IpsaGreen,
                        //     color: 'black',
                        // }}
                        buttonText={
                            goodStanding && !paymentSetup
                                ? 'Enter Payment Information'
                                : 'Manage Account'
                        }
                        isGreen={goodStanding && !paymentSetup}
                        goToCardInfoPage={goodStanding && !paymentSetup}
                    />
                </div>
            </div>
        </div>
    )
}

export default DisplayPlans
